<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            MARÍA JESÚS ALVARADO <br>
            RIVERA (1878 – 1971)<br>
            
        </p>
        <p class="fontMS500 colorPrincipal font-26">PRECURSORA DEL FEMINISMO EN EL PERÚ </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio26/ALVARADO-000.png">
</section>

<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    RECONOCIDA COMO PRECURSORA DEL FEMINISMO EN EL PERÚ, MARÍA JESÚS ALVARADO RIVERA 
                    FUE UNA EDUCADORA, PERIODISTA Y ACTIVISTA APASIONADA QUE CRITICÓ EL SISTEMA PATRIARCAL 
                    EXCLUYENTE HACÍA LA MUJER Y LOS MÁS VULNERABLES DE LA SOCIEDAD. DURANTE TODA SU VIDA 
                    LUCHÓ POR LOS DERECHOS A LA EDUCACIÓN DE NIÑOS Y NIÑAS, LA JUSTICIA HACIA LOS OBREROS 
                    E INDÍGENAS Y, PRINCIPALMENTE, DESTACÓ LA IMPORTANCIA DE LA MUJER, SU NECESARIA AUTONOMÍA 
                    ECONÓMICA, Y SU PARTICIPACIÓN EN LOS ÁMBITOS SOCIALES Y POLÍTICOS.
                    <br>
                </p>

            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-9">
                        <p class="text-justify fontMS100Italic font-24 text-gris">
                            <br>
                            <span>
                                “El principio fundamental del Feminismo es la igualdad de la potencialidad mental
                                y de la habilidad para el trabajo del hombre y la mujer, igualdad como ya lo hemos visto,
                                probada irrefutablemente por la historia, y hasta por la somera observación de la vida diaria,
                                por cuya identidad de personalidades, es de absoluta justicia que sean iguales ante la ley,
                                libertándose la mujer de la forzosa y muchas veces tiránica y cruel tutela del hombre,
                                que ningún derecho tiene a ejercer supremacía en la pareja humana”  
                            </span>
                        </p>
                        <p class=" fontMS100Italic font-24 text-gris">
                            <span>
                                <br>
                                -María Jesús Alvarado 
                            </span>
                            <br>
                        </p>
                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE2.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            SU FAMILIA Y LA DEBACLE <br>
                            DE LA GUERRA DEL <br>
                            PACÍFICO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-justify  font-24">
                    <br><br>
                    MARÍA JESÚS ALVARADO RIVERA NACIÓ EL 27 DE MAYO DE 1878 EN LA HACIENDA CHACRABAJO, 
                    CHINCHA BAJA, EN EL DEPARTAMENTO DE ICA. FUE LA DÉCIMA DE TRECE HERMANOS. SUS PADRES, 
                    CAYETANO ALVARADO ARCINIGA Y JESÚS RIVERA MARTÍNEZ, ERAN PROPIETARIOS DE LA HACIENDA 
                    CHACRABAJO, LA MISMA QUE ERA ADMINISTRADA POR SU PADRE CAYETANO.
                    <br>
                </p>
                <p class="text-justify  font-24">
                    <br>
                    La Guerra del Pacífico, al generar desbalances y fracasos financieros en la economía familiar, 
                    contribuyó a la separación de sus padres, un matrimonio típico del siglo XIX arreglado por conveniencia. 
                    Es así, que junto a su madre, figura decisiva en su vida, María Jesús se establecería en la ciudad de Lima.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="imgNP" width="100%"
                            src="/assets/images/micrositio/micrositio26/ALVARADO-001.png">
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5" style="margin-top:10%">
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                            <p class="text-white text-justify fontMS100Italic font-20">
                                <br><br>
                                <span class="fontMS500Italic" >
                                    Lámina del retrato de María Jesús Alvarado Rivera.
                                </span>
                                    En: El feminismo (Conferencia leída en la Sociedad 
                                    Geográfica de Lima el 28 de Octubre de 1911): Educación femenina.  
                                    Estudio de las cuestiones propuestas por la Comisión encargada 
                                    de elaborar un proyecto de ley de instrucción.
                                    Cód. de identificación: 0000078378. Depósito del 5to Piso / Sector II. 
                                    Biblioteca Nacional del Perú. Av. De la Poesía 160, San Borja. Lima – Perú.
                                    <br><br><br>
                            </p>
                    
                        <img  width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            SU RESIDENCIA EN LIMA
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                </div>
                <div class="row" style="margin-top: 5%">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify  font-24">
                            <br><br>
                            Jesús Rivera Martínez, madre de María Jesús, fue una mujer ilustrada que 
                            participaba en las veladas literarias de Lima, además de frecuentar el teatro, 
                            los conciertos y las exposiciones. Siempre tuvo el interés de suscribirse a 
                            revistas de ciencia y letras, así como de ejemplares de literatura universal.
                            <br>
                        </p>
                    </div>

                    <div class="col-sm-4 mt-5 text-right">
                        <img class="img_posicion"
                            src="/assets/images/micrositio/micrositio26/ALVARADO-002.png">
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="text-justify font-24">
                            <br>
                            María Jesús adquirió el hábito voraz de la lectura precozmente, 
                            lo que contribuyó a ampliar su visión crítica ante la realidad que lo rodeaba, llena de 
                            inequidades y desigualdades que sufrían tanto las mujeres, como otros grupos sociales, 
                            tales como los niños, los obreros y los indígenas.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40">
                            LA REFORMA DE LA ENSEÑANZA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                </div>
                <p class="text-justify text-white fontMS500 font-24">
                    <br><br>
                    MARÍA JESÚS CURSÓ EN LIMA LOS TRES AÑOS DE PRIMARIA, ENTRE 1893-1895, Y FUE UNA ESTUDIANTE SOBRESALIENTE. 
                    SUS MAESTRAS, AL ADVERTIR SU PRECOZ FORMACIÓN Y CAPACIDADES REFLEXIVAS, LE ENCARGARON LOS DISCURSOS 
                    DE FIN DE AÑO. LUEGO DE TERMINAR LA PRIMARIA, QUISO SEGUIR ESTUDIOS SECUNDARIOS Y UNIVERSITARIOS, 
                    PERO LAS CARENCIAS ECONÓMICAS SE LO IMPIDIERON.
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                            <img width="100%" src="/assets/images/micrositio/micrositio26/ALVARADO-003.jpg">
                    </div>
                    <p class="text-center text-white fontMS100Italic font-18">
                        <br>
                        María Jesús Alvarado(Chincha Alta, 1878 - Lima, 1971) Fuente: CMP Flora Tristán
                        <br>
                    </p>
                    <div class="col-som-3">
                        <br>
                    </div>
                </div>
                <p class="text-justify text-white fontMS100 font-24">
                    
                    No obstante, el ámbito de la enseñanza fue una de sus pasiones. Por ello, 
                    interesada en compartir sus conocimientos, fue profesora en un colegio estatal. 
                    Su experiencia con las ineficiencias del sistema educativo, la motivaron a cuestionar 
                    la forma en que regularmente se impartían las clases. Como resultado de esa experiencia, 
                    impulsó una reforma de la enseñanza.
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            SU COMPROMISO <br>
                            SOCIAL
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                </div>

                <div class="row">
                    <div class="col-sm-12 " style="margin-top: 10%">
                        <p class="text-justify fontMS500 font-24">
                            LA SOSTENIDA Y PERMANENTE REFLEXIÓN CRÍTICA DE MARÍA JESÚS ALVARADO SE DIFUNDIÓ A TRAVÉS DE SUS COLUMNAS EN EL DIARIO, 
                            EL COMERCIO Y LA PRENSA. SIEMPRE ESTUVO ABOCADA A LLAMAR LA ATENCIÓN DEL ABANDONO EN QUE SE ENCONTRABAN LOS OBREROS, 
                            LOS INDÍGENAS, LAS MUJERES Y OTROS GRUPOS VULNERABLES.
                        </p>
                        <p class="text-justify  font-24">
                            <br>
                            En sus escritos, instó a la sociedad a reflexionar que era de suma urgencia revertir 
                            tal situación de injusticia, resaltando los problemas de la educación, la jornada laboral de 8 horas, 
                            la importancia de la participación política de las mujeres, así como la defensa de sus derechos civiles. 
                            Asimismo, integró la Asociación Pro-Indígena, junto a Dora Mayer y Pedro Zulen, 
                            institución que luchó por la defensa de los indígenas.
                            <br><br>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_NEGRO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40">
                            EL FEMINISMO <br>
                            (28 DE OCTUBRE DE 1911)
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_NEGRO.png">
                    </div>
                </div>
                <p class="fontMS700 text-center  font-40" style="margin-bottom: 0%;">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_NEGRO.png">
                </div>
                <div class="row">
                    <div class="col-sm-12 " style="margin-top: 10%">
                        <p class="text-justify fontMS500 font-24">
                            El 28 de octubre de 1911 María Jesús Alvarado impartió la conferencia El Feminismo ante la Sociedad Geográfica de Lima, 
                            que marcaría un hito en la historia del feminismo en el Perú. En esa ocasión presentó un ideario explicando 
                            la situación de las mujeres en el Perú, y expuso, sólidamente, los argumentos para demostrar su capacidad 
                            por encima de los prejuicios imperantes del sistema patriarcal, que la mantenían en una suerte de “esclavitud”.
                        </p>
                    </div>
                </div>
                <div class="fondoBlanco_Centro mt-5">
                    <div class="row">
                        <div class="col-sm-4">
                            <a href="http://hdl.handle.net/20.500.14428/79602" target="_blank" style="color: black;">
                                <img width="100%" src="/assets/images/micrositio/micrositio26/ALVARADO-004.png">
                            </a>
                        </div>
                        <div class="col-sm-8 mt-5">
                            <p class="text-justify font-24 mt-5 p-5">
                                <br>
                                <span class="fontMS500Italic">Ejemplar de la conferencia de MJA, realizada en la Sociedad Geográfica de Lima, 
                                el 28 de octubre del 1911.</span><br>
                                Cód. de identificación: 5275.  Depósito del 5to Piso / Sector II. 
                                Biblioteca Nacional del Perú. Av. De la Poesía 160, San Borja. Lima – Perú.
                                <br><br>
                            </p>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 " >
                        <p class="text-justify  font-24">
                            <br>
                            A decir de sus investigadoras, El Feminismo fue el primer documento institucional que formalizó 
                            el avance del feminismo en nuestro país. En este, María Jesús Alvarado exige, no solo que se 
                            instauren derechos para las mujeres en los ámbitos educativos, sino que se permita su participación 
                            en actividades laborales públicas y en la toma de decisiones políticas. Asimismo, 
                            aboga por su independencia y autonomía económica.
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12 ">
                        <p class="text-justify fontMS500 font-24">
                            MARÍA JESÚS ALVARADO SEÑALA LAS SIGUIENTES 
                            REFORMAS QUE CON URGENCIA CONSIDERÓ DEBERÍAN REALIZARSE: 
                        </p>
                    </div>
                </div>

                <div class="container mt-5">
                    <div class="row">
                      <!-- Columnas superiores -->
                      <div class="col-md-1"></div>
                        <div class="col-md-5">
                            <div class="col-md-12 p-4 mt-3" style="background-color: #8d00b6;">    
                                <p class="text-white text-justify fontMS500 font-45 ">
                                    1.
                                </p>
                                <p class="text-white text-justify fontMS100 font-20 px-5 ">
                                    Dar mayor amplitud y facilidades a la educación de la mujer, 
                                    desarrollando su intelecto y amplitudes de igual manera que 
                                    en el hombre;
                                    <br><br>
                                </p>
                            </div>
                        </div>
                        
                        <div class="col-md-5">
                            <div class="col-md-12 p-4 mt-3 " style="background-color: #8d00b6;">     
                                <p class="text-white text-justify fontMS500 font-45 ">
                                    2.
                                </p>
                                <p class="text-white text-justify fontMS100 font-20 px-5">
                                    Darle acceso a los empleos públicos y profesionales liberales, 
                                    para que pueda subsistir por sus propios esfuerzos, mejorando 
                                    su condición económica y social; 
                                    <br><br>
                                </p>
                            </div>
                        </div>
                     <div class="col-md-1"></div>
                      <!-- Espacio entre las filas -->
                      <div class="w-100"></div>
                  
                      <!-- Columnas inferiores -->
                      <div class="col-md-1"></div>
                      <div class="col-md-5 ">
                        <div class="col-md-12 p-4 mt-3 " style="background-color: #8d00b6;">    
                            <p class="text-white text-justify fontMS500 font-45 ">
                                3.
                            </p>
                            <p class="text-white text-justify fontMS100 font-20 px-5 ">
                                Que se le conceda los mismos derechos civiles que al varón, 
                                libertando a la mujer casada de la dependencia del esposo, 
                                a que la ley la somete, privándola de los derechos de que 
                                goza de soltera:
                                <br>
                            </p>
                        </div>
                    </div>
                    
                    <div class="col-md-5">
                        <div class="col-md-12 p-4 mt-3 " style="background-color: #8d00b6;">     
                            <p class="text-white text-justify fontMS500 font-45 ">
                                4.
                            </p>
                            <p class="text-white text-justify fontMS100 font-20 px-5">
                                Que se le otorguen los derechos políticos para poder intervenir 
                                directamente en los destinos nacionales, como miembro inteligente 
                                y apto que es del Estado.
                                <br>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-1"></div>
                    </div>
                  </div>
                <div class="row">
                    <div class="col-sm-12 " style="margin-top: 5%">
                        <p class="text-justify fontM100 font-24">
                            Para María Jesús todas estas reformas iban de la mano con la 
                            corriente de modernización de las sociedades. No era concebible 
                            considerar al Perú como una sociedad democrática y moderna, 
                            sin otorgar a las mujeres igualdad de derechos civiles y políticos.
                            <br><br>
                        </p>
                    </div>
                    <img width="100%" src="/assets/images/micrositio/micrositio26/ALVARADO-005.jpg">
                        <p class="text-center fontMS100Italic font-18">
                            María Jesús Alvarado, Fuente: VMP Flora Tristán
                            <br><br>
                        </p>
                        <p class="text-justify fontM100 font-24">
                            Una versión impresa de esta importante conferencia, 
                            publicada en 1912, es albergada por la BNP.
                            <br><br>
                        </p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40">
                            EVOLUCIÓN FEMENINA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_BLANCO.png">
                </div>
                <p class="text-justify text-white fontMS500 font-24">
                    <br><br>
                    CON EL OBJETIVO DE LLEVAR A LA PRÁCTICA SUS IDEAS MARÍA JESÚS ALVARADO FUNDA, EN 1914, 
                    “EVOLUCIÓN FEMENINA”, LA PRIMERA ORGANIZACIÓN FEMINISTA DE NUESTRO PAÍS, A TRAVÉS DE LA 
                    CUAL ABOGÓ POR LOS DERECHOS CIVILES DE LAS MUJERES. LA BNP CUSTODIA LOS ESTATUTOS DE ESTA ASOCIACIÓN. 
                    <br>
                </p>
                <div class="row mt-5">
                    <div class="col-sm-5" style="background: #ffffff">
                        <div class="col-sm-12 mt-3 px-5 text-center">
                            <a href="http://hdl.handle.net/20.500.14428/79169" target="_blank" style="color: black;">
                                <img width="100%" src="/assets/images/micrositio/micrositio26/ALVARADO-006.png">
                            </a>
                            <p class="text-justify fontMS100Italic font-20">
                                <br>
                                Institución “Evolución Femenina”: EXPOSICION DE PRINCIPIOS: ESTATUTOS. 
                                Aprobados en Junta General de 25 de mayo de 1914                            <br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-6">
                        <p class="text-justify text-white fontMS100 font-24" style="margin-top: 20%">
                            En este documento se redactan los fines y principios de la organización, los 
                            que están orientados al desarrollo de la cultura y la formación educativa de 
                            la mujer para el óptimo desempeño de sus múltiples funciones. Igualmente se 
                            establece las acciones y herramientas necesarias para cumplir sus objetivos, 
                            como el de gestionar con los funcionarios públicos proyectos de ley que permitan 
                            ampliar el campo de acción social de las mujeres, así como el hacer valer sus 
                            derechos en todas las clases sociales.
                            <br>
                        </p>
                    </div>

                </div>
                <p class="text-justify text-white fontMS100 font-24 mt-5">
                    Uno de las primeras conquistas de “Evolución femenina” fue que la Cámara de Diputados aprobara, 
                    en 1915, la ley que permitía el acceso de las mujeres a la Presidencia de la Sociedad de 
                    Beneficencia Pública; así, por primera vez, las mujeres tendrían injerencia pública en la toma 
                    de decisiones desde las instituciones oficiales. Esta ley fue ratificada en 1922 en la Cámara 
                    de Senadores.<br>
                    Asimismo, también desde su Asociación, María Jesús Alvarado Rivera aprovecha la formación 
                    de la Comisión de Reforma del Código Civil de 1851, y solicita el reconocimiento de los Derechos 
                    Civiles femeninos. Este proyecto, que fue aprobado y promulgado, finalmente, en el Código Civil 
                    de 1936, permitió a las mujeres libertad total en la administración de sus vidas y bienes, 
                    sin dependencia alguna de sus esposos.
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-9">
                        <p class="text-justify fontMS100Italic font-24">
                            <br>
                            <span>
                                Evolución femenina, primera asociación que se funda en el Perú para trabajar por 
                                la reforma de la educación femenina y defender los derecho e intereses de la mujer.   
                            </span>
                        </p>
                        <p class=" fontMS100Italic font-24 ">
                            <span>
                                -María Jesús Alvarado 
                            </span>
                            <br>
                        </p>
                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE2.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            ESCUELA MORAL 
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                </div>
                <p class="fontMS700 text-center colorPrincipal font-40" style="margin-bottom: 0%;">
                    Y TRABAJO
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                </div>
                <div class="row">
                    <div class="col-sm-12 " style="margin-top: 10%">
                        <p class="text-justify fontMS500 font-24">
                            LA ESCUELA “MORAL Y TRABAJO”, QUE FUNDÓ EN 1915, FUE OTRO DE LOS GRANDES LOGROS DE 
                            LA ASOCIACIÓN “EVOLUCIÓN FEMENINA”. ESTA ESCUELA TUVO POR FINALIDAD DAR EDUCACIÓN 
                            A LAS JÓVENES DE ESCASOS RECURSOS ECONÓMICOS. SE PUSO EN PRÁCTICA SU REFORMA EN 
                            LA ENSEÑANZA, QUE CONSISTÍA EN ALEJARSE DE LA PRÁCTICA MEMORÍSTICA DE LAS MATERIAS, 
                            Y MÁS BIEN INCORPORAR LA ENSEÑANZA DE OFICIOS ÚTILES QUE LES GENERARAN SUSTENTO 
                            ECONÓMICO Y LES BRINDARAN AUTONOMÍA. TAMBIÉN SE ESMERÓ EN PREPARAR A LAS MUJERES 
                            PARA UN MEJOR DESEMPEÑO EN SU ROL COMO FUTURAS MADRES Y ESPOSAS.
                        </p>
                    </div>
                </div>
                <div class="fondoMorado_Centro mt-5">
                    <div class="row">
                        <div class="col-sm-6 mt-5">
                            <p class="text-justify text-white font-24 mt-5 p-5">
                                <br>
                                <span class="fontMS500Italic">MORAL y TRABAJO: ESCUELA PARA NIÑAS DE ARTES É 
                                INDUSTRIAS FUNDADA POR LA SOCIEDAD Evolución Femenina, EL 18 DE JULIO DE 1915</span><br>
                                Archivo - Sección Evolución Femenina, Colección María Jesús Alvarado. Biblioteca 
                                del Centro de la Mujer Peruana Flora Tristán. Parque Hernán Velarde Nº 42. Lima 1.Perú.
                                <br><br>
                            </p>
                        </div>
                        <div class="col-sm-6 ">
                            <a href="http://hdl.handle.net/20.500.14428/79601" target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio26/ALVARADO-008.png">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 " >
                        <p class="text-justify  font-24">
                            <br><br>
                            El preocuparse por el rol de madre, muy lejos de ser un enfoque conservador significó, 
                            por el contrario, una visión moderna de incrementar las capacidades de las mujeres de ese 
                            entonces. <br>
                            Los cursos que esta escuela impartió fueron: Moral práctica, Educación cívica, ocupaciones 
                            e industrias femeninas: construcción de objetos de paja, conservas, confituras, teñidos, 
                            hilados de algodón y lana; cursos de higiene, aritmética, castellano, música y juegos 
                            rítmicos.

                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_NEGRO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40">
                            EXILIO Y RETORNO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_NEGRO.png">
                    </div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_NEGRO.png">
                </div>
                <div class="row">
                    <div class="col-sm-12 " style="margin-top: 10%">
                        <p class="text-justify fontMS500 font-24">
                            EL COMPROMISO SOCIAL DEL FEMINISMO DE MARÍA JESÚS ALVARADO LA LLEVA A ABOGAR TAMBIÉN, 
                            DESDE OTRAS INSTITUCIONES, POR LA DEFENSA DE LOS INDÍGENAS Y OBREROS. SU ACTITUD DE 
                            CRÍTICA Y DEMANDA SOCIAL INCOMODABA AL GOBIERNO DE TURNO.
                        </p>
                    </div>
                </div>
                    <div class="row">
                        <div class="col-sm-4 mt-5">
                            <img width="100%" src="/assets/images/micrositio/micrositio26/ALVARADO-007.png">
                        </div>
                        <div class="col-sm-8 mt-5">
                            <p class="text-justify font-24 mt-3 p-5">
                                Por ello, al advertir que María Jesús aceptaba imprimir volantes que denunciaban 
                                arbitrariedades del gobierno del presidente Leguía en la imprenta de su escuela 
                                “Moral y trabajo”, fue apresada, encarcelada y, posteriormente, exiliada.
                                <br>
                                <br>
                                María Jesús Alvarado permaneció en Argentina, por 12 años, hasta 1937.
                                <br><br>
                            </p>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            NOVELISTA, ESCRITORA Y 
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                    </div>
                </div>
                <p class="fontMS700 text-center colorPrincipal font-40" style="margin-bottom: 0%;">
                    GESTORA DE INSTITUCIONES <br>
                    CULTURALES PARA EL <br>
                    DESARROLLO DE LAS ARTES
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio26/ET04_MS012_MAGDA_LINEA_RESALTE_MORADO.png">
                </div>
                <div class="row">
                    <div class="col-sm-12 " style="margin-top: 10%">
                        <p class="text-justify fontMS500 colorPrincipal font-24" >
                            MARÍA JESÚS ESCRIBIÓ LA NOVELA NUEVAS CUMBRES, EN 1923, OBRA QUE SUS ESTUDIOSOS 
                            CONSIDERAN AUTOBIOGRÁFICA. TAMBIÉN ESCRIBIÓ LA PERRICHOLI, PRIMERA RADIONOVELA 
                            QUE SE DIFUNDIÓ EN NUESTRO PAÍS ASÍ COMO MANUELA SÁENZ. ADEMÁS, CON SUS RECURSOS, 
                            FUNDÓ LA ACADEMIA DE ARTE DRAMÁTICO “OLLANTAY”.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 " >
                        <p class="text-justify  font-24">
                            <br><br>
                            Produjo el programa radial “Ante la vida” y presentó al Ministerio de Educación un 
                            proyecto para la creación de la Dirección de Extensión Cultural y Artística que se 
                            concretó al poco tiempo. 

                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <p class="text-white text-justify font-24">
                    María Jesús Alvarado Rivera fue una activista con profundo compromiso social. 
                    Su feminismo estuvo enmarcado en un deseo de modernidad y progreso que debía liberar a 
                    la mujer de su condición de subordinada; pero, ¿de qué manera?: a través de una educación 
                    moderna y útil, que le permita ganar fortalezas para su desarrollarse en distintos ámbitos; 
                    otorgándole la oportunidad de desempeñarse laboralmente en igualdad de condiciones; y 
                    facultándole los mismos derechos civiles y políticos. 
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Consideras que las reformas propuestas por MJA ya han sido resueltas en nuestra sociedad?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Crees que hoy en día las mujeres tienen las mismas oportunidades laborales que los hombres?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Podemos decir que todas las mujeres de nuestro país tienen las mismas oportunidades 
                            para desarrollarse a plenitud?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 text-center font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Rojas, L. (2009). </span><br>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">María Jesús Alvarado Rivera, 
                                primera feminista peruana. Destiempos. Revista de Curiosidad 
                                Cultural, (19), pp. 209-228. Recuperado de: 
                            <!--   http://www.destiempos.com/n19/rojas.pdf --> <br>
                            </span>
                            <a href="http://www.destiempos.com/n19/rojas.pdf" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Chaney, E. (1988). </span><br>
                            <span class="fontMS100Italic text-gris">Significado de la obra de María 
                                Jesús Alvarado Rivera (Cuadernos Culturales, Serio II). Cusco: 
                                Centro de Documentación de la Mujer (Cendoc-Mujer). </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Margarita Zegarra (2014). </span><br>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">María Jesús Alvarado y el rol de 
                                las mujeres en la construcción de la patria. Revista Historia de las Mujeres, (153), 
                                Recuperado de: <!-- http://cemhal.org/anteriores/2013_2014/No_153_1.pdf --><br></span>
                            <a href="http://cemhal.org/anteriores/2013_2014/No_153_1.pdf"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Margarita Delfina Zegarra Flórez (2011) </span><br>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">María Jesús Alvarado : la construcción de una 
                                intelectual feminista en Lima, 1878-1915 TESIS para optar el grado académico de 
                                Magíster en Historia. Recuperado de: 
                              <!--   https://cybertesis.unmsm.edu.pe/handle/20.500.12672/1372 --><br>
                            </span>
                            <a href="https://cybertesis.unmsm.edu.pe/handle/20.500.12672/1372"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Miloslavich Túpac, Diana y Jiménez Peña, Carla (2011) </span><br>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">“Guía de la ruta cívica de la ciudad: María Jesús 
                                Alvarado”. -- Lima: Centro de la Mujer Peruana Flora Tristán y El Ministerio de la Mujer 
                                y Desarrollo Social (MIMDES). Recuperado de: 
                               <!-- https://www.flora.org.pe/wp-content/uploads/publicaciones/1.-Ciudades-seguras-para-las-mujeres_-Guia-de-la-ruta-civica-de-la-ciudad-Maria-Jesus-Alvarado.pdf --><br></span>
                            <a href="https://www.flora.org.pe/wp-content/uploads/publicaciones/1.-Ciudades-seguras-para-las-mujeres_-Guia-de-la-ruta-civica-de-la-ciudad-Maria-Jesus-Alvarado.pdf"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>